import { render, staticRenderFns } from "./ListBans.vue?vue&type=template&id=ed51eff0&"
import script from "./ListBans.vue?vue&type=script&lang=js&"
export * from "./ListBans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports